import { Middleware, MiddlewareAPI } from 'redux';

import { AppActions, AppDispatch, AppState } from '..';
import { getSocketConnection, setSocketEventRegister } from '../../services/Socket';
import { SOCKET_IO_CONNECT, SOCKET_IO_DISCONNECT } from './types';
import {
  setNewChatMessage,
  setUpdateChatMessage,
  setUnreadMessageCount,
  setInstantSuggestions,
  setOwnerAssignments,
  setNewOrder,
  setNewOwner,
  setUpdateOwner,
  setNewPriceQuotes,
  setV2Instants,
  setInstantReserve,
  setUpdateXuatHoaDon,
} from '../user/actions';
import CONSTANTS from '../../constants/constant';

export function createSocketMiddleware() {
  const middleware: Middleware = (store: MiddlewareAPI<AppDispatch, AppState>) => {
    return (next) => (action: AppActions) => {
      switch (action.type) {
        case SOCKET_IO_CONNECT:
          // Giữ lại cách đăng ký listener để Socket.ts đăng ký lại sau mỗi lần dựng lại kết nối
          // (mất mạng, máy ngủ, deploy lại chat service). Thiếu bước này thì socket mới không có
          // listener nào và trang im lặng cho tới khi F5.
          setSocketEventRegister((socket: any) => registerSocketEvents(store.dispatch, socket));
          registerSocketEvents(store.dispatch, getSocketConnection());
          return;
        case SOCKET_IO_DISCONNECT:
          getSocketConnection().close(); // TODO of registered events also ???
          return;
        default:
          break;
      }
      return next(action);
    };
  };

  return middleware;
}

function registerSocketEvents(dispatch: AppDispatch, socket: any) {
  socket.removeAllListeners();

  socket.on(CONSTANTS.SOCKET_EVENT.MESSAGE_COUNT, (data: number) => {
    if (data > 0) {
    }
    dispatch(setUnreadMessageCount(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.NEW_MESSAGE, (data: any) => {
    if (data) {
      dispatch(setNewChatMessage(data));
    }
  });

  socket.on(CONSTANTS.SOCKET_EVENT.UPDATE_MESSAGE, (data: any) => {
    dispatch(setUpdateChatMessage(data));
  });

  // Chính người dùng này vừa đọc một nhóm ở TAB KHÁC / THIẾT BỊ KHÁC (web, VIC Chat, app
  // nhân viên đều dùng chung một bộ đếm ở server). Payload mang ảnh chụp TOÀN BỘ bộ đếm
  // theo nhóm — thay nguyên state để mọi tab hiện đúng một con số, khỏi tự cộng trừ.
  socket.on(CONSTANTS.SOCKET_EVENT.UNREAD_UPDATED, (data: any) => {
    try {
      const payload = typeof data === 'string' ? JSON.parse(data) : data;
      if (payload && payload.unread_by_group) {
        dispatch(setUnreadMessageCount(payload.unread_by_group));
      }
    } catch (e) {
      console.log('UNREAD_UPDATED parse error', e);
    }
  });

  socket.on(CONSTANTS.SOCKET_EVENT.NEW_INSTANT_V2, (data: any) => {
    console.log('NEW_INSTANT_V2', data);
    dispatch(setV2Instants(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.NEW_INSTANT_OWNER, (data: any) => {
    console.log('NEW_INSTANT_OWNER', data);
    dispatch(setNewOwner(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.UPDATE_INSTANT_OWNER, (data: any) => {
    console.log('UPDATE_INSTANT_OWNER', data);
    dispatch(setUpdateOwner(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.NEW_ORDER, (data: any) => {
    console.log('NEW_ORDER', data);
    dispatch(setNewOrder(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.NEW_PRICE_QUOTE, (data: any) => {
    console.log('NEW_PRICE_QUOTE', data);
    dispatch(setNewPriceQuotes(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.INSTANT_RESERVE, (data: any) => {
    dispatch(setInstantReserve(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.NEW_OWNER_ASSIGNMENT, (data: any) => {
    dispatch(setOwnerAssignments(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.UPDATE_SUGGESTION, (data: any) => {
    dispatch(setInstantSuggestions(data));
  });

  socket.on(CONSTANTS.SOCKET_EVENT.UPDATE_XUAT_HOA_DON, (data: any) => {
    console.log('UPDATE_XUAT_HOA_DON', data);
    dispatch(setUpdateXuatHoaDon(data));
  });

  socket.on('error', () => {
    window.location.reload();
  });

  socket.on('disconnect', () => {
    if (process.env.NODE_ENV !== 'development') {
      // window.location.reload();
    }
  });
}
